import React from "react";
import { Form } from "react-bootstrap";

export default function ChecklistRenderer({ items = [], editable = false, values = {}, onChange }) {
  if (!items.length) {
    return (
      <div className="process-action-modal-v2__checklist-empty">
        Sin checklist obligatorio para esta instancia.
      </div>
    );
  }

  return (
    <div className="process-action-modal-v2__checklist">
      {items.map((item) => {
        const current = values[item.codigo] || {
          cumplido: !!item.cumplido,
          observacion: item.observacion || "",
        };

        return (
          <div key={item.codigo} className="process-action-modal-v2__checklist-item">
            <Form.Check
              type="checkbox"
              id={`check-${item.codigo}`}
              className="process-action-modal-v2__checkbox"
              label={item.codigo.replaceAll("_", " ")}
              checked={!!current.cumplido}
              disabled={!editable}
              onChange={(event) =>
                onChange?.(item.codigo, {
                  ...current,
                  cumplido: event.target.checked,
                })
              }
            />

            <Form.Control
              placeholder="Observación opcional"
              value={current.observacion || ""}
              disabled={!editable}
              onChange={(event) =>
                onChange?.(item.codigo, {
                  ...current,
                  observacion: event.target.value,
                })
              }
            />
          </div>
        );
      })}
    </div>
  );
}
